/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { RolesControllerUpdateMutationRequest, RolesControllerUpdateMutationResponse, RolesControllerUpdatePathParams, RolesControllerUpdate400, RolesControllerUpdate401, RolesControllerUpdate403, RolesControllerUpdate404 } from "../../models/rolesController/RolesControllerUpdate";

function getRolesControllerUpdateUrl(id: RolesControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/roles/${id}` as const }  
  return res
}

/**
 * @summary Update a custom role (replaces its permission set)
 * {@link /api/v1/roles/:id}
 */
export async function rolesControllerUpdate(id: RolesControllerUpdatePathParams["id"], data?: RolesControllerUpdateMutationRequest, config: Partial<RequestConfig<RolesControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<RolesControllerUpdateMutationResponse, ResponseErrorConfig<RolesControllerUpdate400 | RolesControllerUpdate401 | RolesControllerUpdate403 | RolesControllerUpdate404>, RolesControllerUpdateMutationRequest>({ method : "PATCH", url : getRolesControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}